import settings from 'src/config/settings'

export const omnicomProxy = (value: string) => {
  const serviceURL = settings.omnicomService.httpServer
  if (serviceURL) {
    return serviceURL + value
  }

  return value
}
